import { useLocation } from 'react-router-dom';

import { Links } from 'router/links';

export const useIsConnectionPage = () => {
  const { pathname } = useLocation();

  return pathname.includes(Links.connections);
};
